import { Moment } from 'moment-timezone';

export const earlierMoment = (m1: Moment, m2: Moment): Moment => {
    return m1.isSameOrBefore(m2) ? m1 : m2;
};

export const laterMoment = (m1: Moment, m2: Moment): Moment => {
    return m1.isSameOrAfter(m2) ? m1 : m2;
};

export const earliestMoment = (moments: Moment[]): Moment => {
    return moments.reduce(earlierMoment);
};

export const latestMoment = (moments: Moment[]): Moment => {
    return moments.reduce(laterMoment);
};
